const API_BASE_URL = String(process.env.REACT_APP_BASEURL || "").replace(/\/$/, "");

async function parseJson(response) {
  const text = await response.text();
  if (!text) return {};
  return JSON.parse(text);
}

export async function askPmsChatbot(question, policyId = null, maxResults = 5) {
  const token = localStorage.getItem("token") || "";

  if (!token) {
    throw new Error("PMS login token is missing.");
  }

  const response = await fetch(`${API_BASE_URL}/chatbot/ask`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      question,
      policyId,
      maxResults,
    }),
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data.message || data.error || "Chatbot request failed.");
  }

  if (data?.status && String(data.status).toLowerCase() !== "success") {
    throw new Error(data.message || data.answer || "Chatbot request failed.");
  }

  return data;
}
